<!--
 * @Author: wangjx
 * @LastEditors: yingna.gao
 * @Date: 2022-02-15 16:23:12
 * @LastEditTime: 2022-08-30 11:15:20
 * @Description: 角色权限
-->
<template>
  <div id="roleAssingPermission" class="h100">
    <div class="r-b-title pt-4 pl-6 flex items-center justify-between">
      <div class="flex items-center">
        <span class="vertical-bar fn18 fnM">{{ $t('public.basicInformation') }}</span>
        <span class="text-gray-902 fn12 pl-4">创建时间：</span>
        <span class="text-sub-text-color fn12">{{ userRole.createTime }}</span>

        <span class="text-gray-902 fn12 pl-4">更新时间：</span>
        <span class="text-sub-text-color fn12">{{ userRole.updateTime }}</span>
      </div>

      <div class="pl-24 flex pr-6">
        <svg-icon icon-class="back_green" class="cursor-p" @click="backAction"></svg-icon>
        <span class="text_back" @click="backAction"></span>
      </div>
    </div>

    <div class="des text-sub-text-color fn14 pt-4">
      <div class="h-6">
        <span>角色名称：{{ userRole.roleName }}</span>
        <span class="pl-20">角色编码：{{ userRole.roleCode }}</span>
      </div>
      <div class="h-6">描述：{{ userRole.description }}</div>
    </div>

    <div class="bg-F9 h-2"></div>
    <div class="permission">
      <el-tabs v-model="periodSelected" class="pt-2 ml-5 mr-5 period-tabs">
        <el-tab-pane
          v-for="item in periodList"
          :key="item.value"
          :label="item.label"
          :name="item.value"
        ></el-tab-pane>
      </el-tabs>

      <div class="tree-content">
        <apFunction
          v-show="periodSelected === 'function'"
          class="h100"
          :target-id="userRole.id"
          :client-type="clientType"
          :disabled="true"
        ></apFunction>
        <!-- <apFiled v-show="periodSelected === 'field'" class="h100" :target-id="userRole.id"></apFiled>
        <apData v-show="periodSelected === 'data'" class="h100" :target-id="userRole.id"></apData> -->
        <permission-interface
          v-show="periodSelected === 'interface'"
          class="h100"
          :target-id="userRole.id"
          :disabled="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import apFiled from "@/views/standard/permission/components/assign-permission-field.vue";
import apFunction from "@/views/standard/permission/components/assign-permission-function.vue";
import apData from "@/views/standard/permission/components/assign-permission-data.vue";
import PermissionInterface from "@/views/standard/permission/components/assign-permission-interface";
export default {
  name: "RoleAssingPermissionDetails",
  components: {
    apFiled,
    apFunction,
    apData,
    PermissionInterface
  },
  props: {
    userRole: {
      type: Object,
      default() {
        return {};
      }
    },
    clientType: {
      type: String,
      default() {
        return "WEB";
      }
    }
  },
  data() {
    return {
      periodSelected: "function",
      periodList: []
    };
  },
  mounted() {
    this.initTabsData();
  },
  methods: {
    backAction() {
      this.$emit("backClick");
    },
    initTabsData() {
      if (this.clientType === "WEB") {
        this.periodList = [
          {
            label: "功能权限",
            value: "function"
          },
          // {
          //   label: '字段权限',
          //   value: 'field'
          // },
          // {
          //   label: '资源数据权限',
          //   value: 'data'
          // },
          {
            label: "数据权限",
            value: "interface"
          }
        ];
      } else {
        this.periodList = [
          {
            label: "功能权限",
            value: "function"
          }
        ];
      }
    }
  }
};
</script>

<style lang="scss">
#roleAssingPermission {
  .text_back {
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: 1;
    color: $scim-color-primary;
    cursor: pointer;

    &:hover {
      color: darken($color: $scim-color-primary, $amount: 10%);
    }

    &::after {
      content: '返回';
      margin-left: 4px;
      font-size: 14px;
      line-height: 1;
    }
  }

  .des {
    padding-left: 36px;
    height: 70px;
  }

  .permission {
    height: calc(100% - 116px);
    .period-tabs {
      .el-tabs__header {
        margin: 0;
      }
    }
  }
  .tree-content {
    height: calc(100% - 60px);
  }
}
</style>
